import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { AppConfigService } from "src/app-config.service";
import { GeneralService } from "src/app/service/general-service";
import { NotificationService } from "src/app/service/notification.service";
import { TableSelectionAbstract } from "src/app/shared/component/table/table-selection.abstract";
import { Constant } from "src/app/shared/constants/constant.class";
import { ShareaService } from "src/app/service/sharea.service";
import { Title } from "@angular/platform-browser";
import * as moment from "moment";
import { WarehouseService } from "src/app/service/warehouse.service";

declare var $: any;

@Component({
  selector: "app-warehouse-confirm-import",
  templateUrl: "./warehouse-confirm-import.component.html",
  styleUrls: ["./warehouse-confirm-import.component.scss"],
})
export class WarehouseConfirmImportComponent
  extends TableSelectionAbstract
  implements OnInit
{
  datas: any[] = [];
  filterData: any[] = [];
  searchText: any;
  data: any;
  loading: boolean;
  selectedWarehouseId: any;
  warehouses: any[] = [];
  page: any;
  pageSize: any;
  defaultPage: any;
  pageIndex = 1;
  selectedData: any;
  isVisibleAdd: boolean = false;
  viewOnly: boolean;
  selectedWarehouse: any;
  machines: any[] = [];

  constructor(
    public translate: TranslateService,
    private modalService: NzModalService,
    private generalService: GeneralService,
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private configService: AppConfigService,
    private shareaService: ShareaService,
    private titleService: Title,
    private warehouseService: WarehouseService
  ) {
    super("id");
    this.selectedData = {
      id: 0,
      code: "",
      description: "",
      receiveType: 1,
      recipient: "",
      warehouseExportDetails: [],
      receiverName: "",
      importerName: "",
    };
  }

  ngOnInit(): void {
    this.selectedWarehouseId = localStorage.getItem(Constant.WAREHOUSE_ID);
    this.pageSize = this.configService.getConfig().pageSize;
    this.page = this.configService.getConfig().page;
    this.defaultPage = this.configService.getConfig().defaultPage;
    this.get();
    this.getListData();
    this.getUserWarehouses();
  }

  getUserWarehouses() {
    const userInfo = JSON.parse(localStorage.getItem(Constant.USER_INFO));
    console.log(userInfo);
    this.warehouseService.getWarehousesByUserId(userInfo.id).subscribe(
      (res) => {
        this.warehouses = res;
      },
      (error) => {}
    );
  }

  getMachine() {
    this.generalService.getMachine().subscribe(
      (res) => {
        if (res !== null) {
          this.machines = res;
        }
      },
      (error) => {}
    );
  }

  getListData() {
    const payload = {
      page: this.page,
      pageSize: this.defaultPage,
    };
    this.loading = true;
    this.generalService.getWarehouseExportNeedConfirm(payload).subscribe(
      (res) => {
        if (res !== null) {
          this.datas = res.data;
          this.filterData = res.data;
          super.setListOfAllData(this.datas);
          this.loading = false;
        }
      },
      (error) => {}
    );
  }

  getSelectedWarehouse() {
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
    this.warehouseService.getWarehouseById(this.selectedWarehouseId).subscribe(
      (res) => {
        this.selectedWarehouse = res;
      },
      (error) => {}
    );
  }

  doSearch() {
    const searchs = this.shareaService.toUnsign(this.searchText).trim();
    this.filterData = this.datas.filter((en) =>
      this.shareaService.toUnsign(en.code).includes(searchs)
    );
    console.log("doSearch", this.filterData);
  }

  get() {
    this.translate.use(this.translate.currentLang).subscribe((data) => {
      this.data = data;
    });
  }

  getRowIndex = (index, pageIndex, pageSize) =>
    index + 1 + pageSize * (pageIndex - 1);

  onQueryParamsChange(params): void {
    const { pageSize, pageIndex, sort, filter } = params;
    this.pageIndex = params.pageIndex;
    this.defaultPage = params.pageSize;
    const currentSort = sort.find((item) => item.value !== null);
    this.getListData();
  }

  showConfirm(id): void {
    this.get();
    this.modalService.confirm({
      nzTitle: "Confirm",
      nzContent: "Bạn có muốn xác nhận hay không?",
      nzOkText: "Đồng ý",
      nzCancelText: "Bỏ qua",
      nzOnOk: () => this.confirmReceived(id),
    });
  }

  confirmReceived(data) {
    this.generalService.confirmReceived(data.id).subscribe(
      (res) => {
        if (res !== null && res.isValid) {
          this.notificationService.showNotification(
            Constant.SUCCESS,
            "Xác nhận thành công"
          );
          this.getListData();
        } else {
          this.notificationService.showNotification(
            Constant.ERROR,
            "Xác nhận lỗi"
          );
        }
      },
      (error) => {}
    );
  }

  sendNotification() {
    this.generalService.sendNotification().subscribe(
      (res) => {})
  }

  showDetails(data) {
    this.selectedData = data;
    this.isVisibleAdd = true;
    this.viewOnly = true;
    console.log(data);
  }

  exportPDF() {
    const phieuId = this.selectedData.id;
    const mainUrl =
      this.configService.getConfig().api.reportUrl + "/BridgeXLSDownload.aspx";
    const url =
      mainUrl + `?PhieuId=${phieuId}&report=PhieuXuatKho&WarehouseName=KhoLab`;
    console.log(url);
    window.open(url, "_blank");
  }

  handleCancel() {
    this.isVisibleAdd = false;
  }
}
